module.exports = __webpack_public_path__ + "img/DE00003.6a23f21d.png";